<section class="landing-testimonials">
  <div class="landing-testimonials__inner">
    <h2 class="landing-testimonials__title">{{ 'landing.testimonials.title' | translate }}</h2>

    <div class="landing-testimonials__grid">
      <figure class="t-card" *ngFor="let t of testimonials">
        <span class="t-card__mark" [style.color]="t.accentSoft" aria-hidden="true">”</span>

        <span class="t-card__tag" [style.color]="t.accent" [style.background]="t.accentSoft">
          {{ 'landing.testimonials.' + t.key + '.tag' | translate }}
        </span>

        <h3 class="t-card__headline">{{ 'landing.testimonials.' + t.key + '.headline' | translate }}</h3>
        <blockquote class="t-card__quote">{{ 'landing.testimonials.' + t.key + '.body' | translate }}</blockquote>

        <figcaption class="t-card__author">
          <img *ngIf="!failedPhoto[t.key]; else avatar" class="t-card__photo"
               [src]="t.photo" [alt]="'landing.testimonials.' + t.key + '.name' | translate" (error)="onError(t.key)" />
          <ng-template #avatar>
            <span class="t-card__avatar" [style.color]="t.accent" [style.background]="t.accentSoft" aria-hidden="true">{{ t.initials }}</span>
          </ng-template>

          <span class="t-card__person">
            <span class="t-card__name">{{ 'landing.testimonials.' + t.key + '.name' | translate }}</span>
            <span class="t-card__role">{{ 'landing.testimonials.' + t.key + '.role' | translate }}</span>
          </span>

          <a *ngIf="t.videoUrl" class="t-card__video" [href]="t.videoUrl" target="_blank" rel="noopener noreferrer">
            <span class="t-card__play" aria-hidden="true"></span>
            {{ 'landing.testimonials.watch_video' | translate }}
          </a>
        </figcaption>
      </figure>
    </div>
  </div>
</section>
